import { Injectable } from '@angular/core';
import { HttpLogado } from '../HttpLogado';
import { environment } from '../../environments/environment';
import convertHttpErrorToLocal from 'src/utils/convertHttpErrorToLocal';
import { interpretServerPayment, Payment } from 'src/classes/payment';

@Injectable({
  providedIn: 'root'
})
export class PaymentService {

  constructor(
    private http: HttpLogado
  ) { }

  private async listVariant(variant: string): Promise<Payment[]> {
    try {
      const response: any = await this.http.get(`${environment.baseUrl}${variant}`).toPromise();
      if (!response) {
        throw new Error("Server did not return a reponse to payment listing");
      }
      if (!(response.data instanceof Array)) {
        throw new Error("Unknown response format from server")
      }
      if (response.total !== response.data.length) {
        throw new Error("Server failed at retuning the length of the payment array");
      }
      return response.data.map(interpretServerPayment);
    } catch (err) {
      convertHttpErrorToLocal(err);
    }
  }

  async listAll() {
    return await this.listVariant('/payments/');
  }

  async listCurrentUserPayments() {
    return await this.listVariant('/payments/user');
  }

  async requestContact() {
    try {
      const response: any = await this.http.post(`${environment.baseUrl}/payments/request-contact`, {}).toPromise();
      return response;
    } catch (err) {
      convertHttpErrorToLocal(err);
    }
  }
}
